import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/js/main'

import { useEffect } from 'react';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  RouterProvider,
  useLocation
} from "react-router-dom";
import HomePage from './pages/home-page';
import InternationalPage from './pages/international-page';
import ConsultsPage from './pages/consults-page';
import CommunicationsPage from './pages/communications-page';
import InvestmentPage from './pages/investment-page';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppLayout />}>
      <Route index element={<HomePage />} />
      <Route path="international" element={<InternationalPage page="International" />} />
      <Route path="consults" element={<ConsultsPage page="Consults" />} />
      <Route path="communication" element={<CommunicationsPage page="Communications" />} />
      <Route path="investment" element={<InvestmentPage page="Investment" />} />
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App; 
